import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FRONTEND_LOG_TYPE, FrontendLog } from '@claim-tracker/common/models-ts';
import { catchError, EMPTY } from 'rxjs';

import { environment } from '../../../../environments/environment';

/**
 * Service for logging frontend logs to the server.
 *
 * @author Jesse Bloomster e020902
 */
@Injectable({
	providedIn: 'root'
})
export class FrontendLoggerService {
	private readonly FRONTEND_LOGGER_URL = '/frontendLogger';

	/**
	 * @param http the Angular Http Client
	 */
	constructor(private http: HttpClient) {}

	/**
	 * Log an error to the server.
	 *
	 * @param error the error to log
	 */
	error = (error: unknown) => {
		// log the error to the server if in production; else just log to console for development
		if (environment.production) {
			this.sendLog(
				new FrontendLog(
					FRONTEND_LOG_TYPE.ERROR,
					error instanceof Error ? error?.message : '',
					error instanceof Error ? error?.stack : ''
				)
			);
		} else {
			console.error(error);
		}
	};

	/**
	 * Log a warning to the server.
	 *
	 * @param message the warning message to log
	 */
	warn = (message: string) => {
		// log the warning to the server if in production; else just log to console for development
		if (environment.production) {
			this.sendLog(new FrontendLog(FRONTEND_LOG_TYPE.WARN, message, undefined));
		} else {
			console.warn(message);
		}
	};

	/**
	 * Send the log to the server. If the request fails, there isn't much we can do, so just swallow the error.
	 *
	 * @param log the log to send to the server
	 */
	private sendLog = (log: FrontendLog) =>
		this.http
			.post(this.FRONTEND_LOGGER_URL, log)
			.pipe(catchError(() => EMPTY))
			.subscribe();
}
